import React, { ComponentType, useEffect } from 'react'

type AutoHeightWrapperProps = {
	id: string
	contentId: string
	children: any
}

const AutoHeightWrapper: ComponentType<AutoHeightWrapperProps> = ({ id, contentId, children }) => {
	useEffect(() => {
		const wrapper = document.getElementById(id)
		const content = document.getElementById(contentId)
		if (!wrapper || !content) {
			return
		}
		const resizeObserver = new ResizeObserver(() => {
			const roundedContentHeight = content.offsetHeight
			if (roundedContentHeight > 0) {
				wrapper.style.setProperty('--content-height', `${roundedContentHeight}px`)
			}
		})
		resizeObserver.observe(content)

		return () => {
			resizeObserver.disconnect()
		}
	}, [id, contentId])

	return <div id={id}>{children}</div>
}

export default AutoHeightWrapper
